import React from 'react'
import { Route, Routes } from 'react-router-dom'
import clsx from 'clsx'

import {
  USER_NOTIFICATION_ROUTE,
  USER_NOTIFICATION_SETTING_ROUTE,
  USER_ORG_ROUTE,
  USER_REF_ROUTE,
  USER_TEAM_ROUTE,
  USER_TRASH_ROUTE,
} from '@/shared/constants'
import { RoutePropsWithComponent } from '@/shared/routes'

import { LayoutFallback } from '../../components/Layout'
import SidebarMenu, { Sidebar } from '../../components/Sidebar'
import MyNotificationsPage from './MyNotifications'
import MyNotificationSettingsPage from './MyNotificationSettings'
import MyOrganizationsPage from './MyOrganizations'
import MyProfilePage from './MyProfile'
import MyReferralPage from './MyReferral'
import MyTeamsPage from './MyTeams'
import MyTrashPage from './MyTrash'
import { userNavLink } from './shared'
import { UserTrashMenuItem } from './UserTrashMenuItem'

/**
 * user account setting routes
 * -> `/u/{userRoutes}`
 */
const userRoutes: RoutePropsWithComponent[] = [
  {
    path: '',
    name: 'My Profile',
    index: true,
    icon: 'User16',
    component: MyProfilePage,
  },
  {
    path: USER_NOTIFICATION_ROUTE,
    name: 'My Notifications',
    icon: 'Notif16',
    component: MyNotificationsPage,
  },
  /*{
    path: `${USER_INVITATIONS_ROUTE}/*`,
    name: 'My Invitations',
    icon: 'Sms16',
    component: UserMyInvitationPages
  },*/
  {
    path: USER_ORG_ROUTE,
    name: 'My Organizations',
    icon: 'Building16',
    component: MyOrganizationsPage,
  },
  {
    path: USER_TEAM_ROUTE,
    name: 'My Teams',
    icon: 'Team16',
    component: MyTeamsPage,
  },
  {
    path: USER_REF_ROUTE,
    name: 'My Referral Link',
    icon: 'ShareAlt16',
    component: MyReferralPage,
  },
  {
    path: USER_NOTIFICATION_SETTING_ROUTE,
    name: 'Notifications Settings',
    icon: 'Setting24',
    component: MyNotificationSettingsPage,
  },
  {
    path: USER_TRASH_ROUTE,
    name: 'Trash',
    icon: 'Trash16',
    component: MyTrashPage,
    showOnNav: false,
  },
]

/**
 * main user dashboard
 * all routes will be redirected to this page if not found
 *
 */
export default function UserRoutes() {
  return (
    <>
      <div id='user-dashboard' className='wrapper'>
        <Sidebar
          menu={
            <SidebarMenu showAvatar={true} menu={userRoutes} getTo={userNavLink}>
              <UserTrashMenuItem />
            </SidebarMenu>
          }
        />
        <div className={clsx('flex-1 overflow-auto mk-scroll h-full')}>
          <React.Suspense fallback={<LayoutFallback />}>
            <Routes>
              {userRoutes.map(({ name, component: Comp, ...r }) => {
                return (
                  <Route
                    key={'settings-' + name}
                    path={r.index ? undefined : r.path}
                    index={r.index}
                    element={<Comp title={name} />}
                  />
                )
              })}
            </Routes>
          </React.Suspense>
        </div>
      </div>
    </>
  )
}
